import React from "react";
import cx from "classnames";
import "./Link.scss";

type LinkProps = {
  children: React.ReactNode;
  href?: string;
  className?: string;
  style?: React.CSSProperties;
  title?: string;
  active?: boolean;
  target?: "_blank" | "_self" | "_parent" | "_top";
  variant?: "neutral" | "brand";
  rel?: string;
  onClick?: (
    e:
      | React.MouseEvent<HTMLAnchorElement>
      | React.MouseEvent<HTMLButtonElement>,
  ) => void;
  onMouseOver?: (
    e:
      | React.MouseEvent<HTMLAnchorElement>
      | React.MouseEvent<HTMLButtonElement>,
  ) => void;
  onMouseOut?: (
    e:
      | React.MouseEvent<HTMLAnchorElement>
      | React.MouseEvent<HTMLButtonElement>,
  ) => void;
  as?: "a" | "button";
};

const Link: React.FC<LinkProps> = ({
  children,
  href,
  className,
  active = false,
  target,
  rel,
  onClick,
  variant = "neutral",
  as = "a",
  onMouseOver,
  onMouseOut,
}) => {
  // If target is _blank, ensure rel includes noopener noreferrer for security
  const safeRel =
    target === "_blank" ? `noopener noreferrer ${rel || ""}`.trim() : rel;

  const linkClasses = cx(
    "Link",
    {
      "Link--Active": active,
      "Link--Brand": variant === "brand",
    },
    className,
  );

  return as === "a" ? (
    <a
      className={linkClasses}
      href={href}
      target={target}
      rel={safeRel}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {children}
    </a>
  ) : (
    <button
      className={linkClasses}
      onClick={onClick}
      onMouseOver={onMouseOver}
      onMouseOut={onMouseOut}
    >
      {children}
    </button>
  );
};

export { Link };
